import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import Dropzone from 'react-dropzone'
import Checkbox from 'material-ui/Checkbox'
import { RaisedButton } from 'material-ui'
import { regeneratePdf, replaceOrderItem, fetchSalesChannels, fetchItems, fetchProducts, } from '../../../../actions'


const styles = {
  h3: {
    fontSize: '20px',
    marginTop: '10px',
  },
  downloadDiv: {
    marginTop: '10px',
  },
  downloadLink: {
    color: 'black',
    marginRight: '10px',
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '10px',
    display: 'block'
  },
  itemDiv: {
    lineHeight: '20px',
    fontSize: '14px',
    wordWrap: 'break-word',
    maxWidth: '300px'
  },
  value: {
    fontWeight: '600',
  },
  dropzonebutton: {
    display: 'inline-block',
    cursor: 'pointer',
    position: 'relative',
    lineHeight: '36px',
    borderRadius: '2px',
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    backgroundColor: 'rgb(0, 188, 212)',
    fontSize: '14px',
    paddingLeft: '16px',
    paddingRight: '16px',
    color: 'rgb(255, 255, 255)',
    display: 'block',
    maxWidth: '150px',
    marginTop: '20px'
  }
}

const textStyle = {
  margin: '12px',
  textAlign: 'center',
  display: 'inline-block',
  backgroundColor: 'rgba(255, 7, 7, 0.18)', // rgba(7, 106, 255, 0.18)--blue
  fontFamily: 'sans-serif',
  padding: '20px',
  lineHeight: '20px',
  fontSize: '14px',
  wordWrap: 'break-word',
  maxWidth: '300px'
}

const propTypes = {
  items: PropTypes.object,
  products: PropTypes.any,
  // item: PropTypes.any,
  // product: PropTypes.object
}
const itemProperties = (item) => [{
  label: 'Line Item Id: ',
  value: item.line_item_id
}, {
  label: 'Item Id: ',
  value: item.id
}, {
  label: 'Sage Line Item Id: ',
  value: item.order_line_id
}, {
  label: 'Item Name: ',
  value: item.name,
}, {
  label: 'Sku: ',
  value: item.sku,
}, {
  label: 'Quantity: ',
  value: item.qty,
}, {
  label: 'Unit Price: ',
  value: item.unit_price,
}, {
  label: 'Total: ',
  value: item.total,
}, {
  label: 'Number of Photos: ',
  value: item.num_photos,
}]
const itemPersonalization = (item, i) =>
  [{
  }, {
    label: 'Brightness: ',
    value: `${(item.photopersonalization && item.photopersonalization[i].edits && item.photopersonalization[i].edits.brightness)
      ? (item.photopersonalization[i].edits.brightness.toFixed(3) * 100) : 0}%`,
  }, {
    label: 'Rotation: ',
    value: `${(item.photopersonalization && item.photopersonalization[i].edits && item.photopersonalization[i].edits.rotation)
      ? (item.photopersonalization[i].edits.rotation) : 0}°`,
  }, {
    label: 'Image X: ',
    value: `${(item.photopersonalization && item.photopersonalization[i].edits && item.photopersonalization[i].edits.imageX)
      ? item.photopersonalization[i].edits.imageX.toFixed(3) : 0}%`,
  }, {
    label: 'Image Y: ',
    value: `${(item.photopersonalization && item.photopersonalization[i].edits && item.photopersonalization[i].edits.imageY)
      ? item.photopersonalization[i].edits.imageY.toFixed(3) : 0}%`,
  }, {
    label: 'Image Width: ',
    value: `${(item.photopersonalization && item.photopersonalization[i].edits && item.photopersonalization[i].edits.imageWidth)
      ? item.photopersonalization[i].edits.imageWidth.toFixed(3) : 100}%`,
  }, {
    label: 'Image Height: ',
    value: `${(item.photopersonalization && item.photopersonalization[i].edits && item.photopersonalization[i].edits.imageHeight)
      ? item.photopersonalization[i].edits.imageHeight.toFixed(3) : 100}%`,
  }, {
    label: 'Thumbnail Url: ',
    value: (item.photopersonalization && item.photopersonalization[i].images && item.photopersonalization[i].images[0] && item.photopersonalization[i].images[0].url)
      ? item.photopersonalization[i].images[0].url : '',
  }]
class Items extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      itemsArray: ' ',
    }
    this.renderOrderItems = this.renderOrderItems.bind(this)
  }

  componentWillMount() {
    this.props.dispatch(fetchSalesChannels({ limit: 1000 }));
    this.props.dispatch(fetchItems({ limit: 1000 }))
    this.props.dispatch(fetchProducts({ limit: 1000 }));
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.items) {
      this.setState({
        itemsArray: nextProps.items.results
      })
    }
    if (nextProps.order) {
      this.setState({ order: nextProps.order })
    }
  }

  downloadEditedImage(i, j, item_id) {
    const { order } = this.props
    if (order && order.processing && order.processing.image && order.processing.image.images && order.processing.image.images.length) {
      // const this_item = order.processing.image.images.find(p => p.itemId === i || p.itemId === j)
      // return this_item ? this_item.imageUrl : null
      const oldOrder = Date.parse(order.orderDate) < Date.parse("2019-04-30 11:00:00Z")
      const this_item = order.processing.image.images.find((image) => {
        if (oldOrder) {
          return (image.itemId === item_id || image.itemId === j)
        } else {
          return (image.imageUrl.split('_')[1] === `${item_id}` && image.imageUrl.split('_')[2] === `${i}.jpg`)
        }
      })
      return this_item ? this_item.imageUrl : null
    }
    return null;
  }
  downloadPdf(i, j, item_id) {
    const { order } = this.props
    if (order && order.processing && order.processing.pdf && order.processing.pdf.pdfs && order.processing.pdf.pdfs.length) {
      // const this_item = order.processing.pdf.pdfs.find(p => p.itemId === i || p.itemId === j)
      const oldOrder = Date.parse(order.orderDate) < Date.parse("2019-04-30 11:00:00Z")
      const this_item = order.processing.pdf.pdfs.find(p => {
        if (oldOrder) {
          return (p.itemId === item_id || p.itemId === j)
        } else {
          if (p.pdfUrl) {
            return (p.pdfUrl.split('_')[1] === `${item_id}` && p.pdfUrl.split('_')[2] === `${i}`)
          } else {
            return null
          }
        }
      })
      return (this_item && this_item.pdfUrl) ? this_item.pdfUrl : null
    }
    return null;
  }
  regenPdf(i, itemIndex) {
    const { order, items } = this.props
    if (order && order.processing && order.processing.pdf
      && order.processing.pdf.pdfs && order.processing.pdf.pdfs[i] && order.processing.pdf.pdfs[i]) {
      const isLandscape = (order.items[itemIndex].photopersonalization[i].images[0].actualSize.width > order.items[itemIndex].photopersonalization[i].images[0].actualSize.height);
      const this_item = _.find(items.results, ['sku', order.items[itemIndex].sku]);
      // const this_product = _.find(products.results, ['id', this_item.productId]);
      const size = isLandscape ? this_item.printData.landscape[i] : this_item.printData.portrait[i]
      const pdf_payload = {
        pdfSavePath: `${order.id}/${order.id}_${order.items[itemIndex].id}_${i}_${order.items[itemIndex].qty}.pdf`,
        pdfSaveBucket: 'focus-order-item-pdfs',
        sku: order.items[itemIndex].sku,
        itemId: this_item.id,
        pages: [
          {
            locationBucket: 'focus-image-processing',
            location: `${order.id}/${order.id}_${order.items[itemIndex].id}_${i}.jpg`,
            pdfImageX: 0,
            pdfImageY: 0,
            pdfImageWidth: size.width * 72,
            pdfImageHeight: size.height * 72,
            pdfWidth: size.width * 72,
            pdfHeight: size.height * 72,
            isLandscape,
            bleed: isLandscape ? this_item.printData.landscape[i].bleed : this_item.printData.portrait[i].bleed,
            fontColor: null,
            fontSize: null,
            font: null,
            text: null,
            textX: null,
            textY: null,
            ribbonHeight: null,
            ribbonColor: null,
            ribbonOn: null,
            ribbonY: null,
          },
        ],
      };
      alert('PDF Regenerated');
      return this.props.dispatch(regeneratePdf(pdf_payload, order, i, order.items[itemIndex]))
    }
    console.log('No order found. Failed to regen PDF.');
    alert('An Error Occurred.');
    return null;
  }
  onDrop(file, i, photoIndex) {
    this.setState({ openSnackbar: true, snackbarMessage: 'Processing new image...' });
    const { dispatch, order } = this.props
    const oldOrder = Date.parse(order.orderDate) < Date.parse("2019-04-30 11:00:00Z")
    //console.log('Order is an oldOrder----->', oldOrder)
    const this_item = order.items.find(x => x.id === i || x.line_item_id === i)
    // console.log('this_item: ', this_item)
    const orderItem = _.find(this.state.itemsArray, ['sku', this_item.sku]);
    // console.log('orderItem: ', orderItem)
    dispatch(replaceOrderItem(file, order, this_item, orderItem, photoIndex, oldOrder));
  }
  photopersonalization(item, styles, hideView) {
    return <div>
      {item.photopersonalization.map((pp, i) => {
        return <div className="row">
          <div className="col-lg-6 col-sm-12">
            <h3 style={styles.h3}>Photo Personalization</h3>
            <Checkbox
              label="Personalized"
              checked={pp.personalized}
              name="photopersonalization.personalized"
            />
            {itemPersonalization(item, i).map(({ label, value }) => (
              <div style={styles.itemDiv}>{label}<span style={styles.value}>{value}</span></div>
            ))}
          </div>
          <div className="col-lg-6 col-sm-12" key={`${i}`} style={{ paddingTop: '20px', height: '340px' }}>
            <img
              style={{ maxWidth: '100%', maxHeight: '300px' }}
              src={pp.personalized && pp.sku !== 'GIFTMSG'
                ? pp.images[0].url
                : pp.personalized && pp.sku === 'GIFTMSG'
                  ? 'https://s3.amazonaws.com/focus-product-images/WebsiteMainImages_18_GN.jpg'
                  : pp.previewObj.productImg}
            />
          </div>
        </div>
      })}
    </div>
  }
  pdfButtons(item, styles, hideView, itemIndex) {
    return <div>
      {item.photopersonalization.map((pp, i) => {
        return (
          <div style={{ paddingTop: '20px', height: '340px' }}>
            {pp.personalized &&
              <div>
                <a target="_blank" style={styles.downloadLink} href={pp.images[0].originalUrl} download>Download Original Image</a>
                <a target="_blank" style={styles.downloadLink} href={this.downloadEditedImage(i, item.line_item_id, item.id)} download>Download Edited Image</a>
                <a target="_blank" style={styles.downloadLink} href={this.downloadPdf(i, item.line_item_id, item.id)} download>Download PDF</a>
                <div style={{ display: hideView }} className="col-lg-4  col-md-12 col-sm-8">
                  <RaisedButton
                    style={{ marginTop: '10px' }}
                    label="REGEN PDF"
                    primary
                    onClick={() => { this.regenPdf(i, itemIndex); }}
                  />
                  <Dropzone
                    ref="dropzone"
                    accept="image/jpeg, image/png, image/gif"
                    style={styles.dropzonebutton}
                    onDrop={(file) => { this.onDrop(file, item.id, i) }}>
                    REPLACE PHOTO
                  </Dropzone>
                </div>
              </div>}
          </div>
        )
      })}
    </div>
  }
  renderOrderItems() {
    const hideView = this.props.disableView ? 'none' : 'inline'
    const { order } = this.state
    if (order && order.items && order.items.length) {
      return order.items.map((item, i) =>
        <tr name={`#${item.id}`}>
          <td style={{ padding: '10px 20px' }}>
            <div className="row" key={i}>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <h3 style={styles.h3}>Item</h3>
                {itemProperties(item).map(({ label, value }) => (
                  <div style={styles.itemDiv}>{label}<span style={styles.value}>{value}</span></div>
                ))}
                {item.photopersonalization.map((item) => {
                  if (item.edits.hasOwnProperty('text')) {
                    return <div style={textStyle}>
                      <p>Custom Text: {item.edits.text}</p>
                    </div>
                  }
                })}
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                {this.photopersonalization(item, styles, hideView)}
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                {this.pdfButtons(item, styles, hideView, i)}
              </div>
            </div>
          </td>
        </tr>
      )
    }
    return <p>No Items to display</p>
  }
  render() {
    return (
      <div>
        <h2>Order Items</h2>
        <div style={{ padding: '0 20px 20px 20px' }}>
          <table className="table table-striped" style={{ width: '100%' }}>
            <tbody>
              {this.renderOrderItems()}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

Items.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    items: state.items,
    // item: state.items.item,
    products: state.products,
    order: state.orders.order,
    // product: state.products.product
  };
}
export default connect(mapStateToProps)(Items)


// WEBPACK FOOTER //
// ./src/components/orders/Common/Items/Items.js